import React from "react";
import PropTypes from "prop-types";

function TeamMembersTable({ columns, rows, tableClassName }) {
  return (
    <div className="team-members-table-wrap">
      <table className={`team-members-table ${tableClassName}`.trim()}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} scope="col" className={column.thClassName}>
                {column.name}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id}>
              {columns.map((column) => (
                <td
                  key={column.key}
                  className={column.tdClassName}
                  title={column.getCellTitle ? column.getCellTitle(row) : undefined}
                >
                  {column.formatter ? column.formatter(row) : row[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

TeamMembersTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      thClassName: PropTypes.string,
      tdClassName: PropTypes.string,
      getCellTitle: PropTypes.func,
      formatter: PropTypes.func,
    }),
  ).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  tableClassName: PropTypes.string,
};

TeamMembersTable.defaultProps = {
  tableClassName: "",
};

export default TeamMembersTable;
